import * as React from 'react'
import { configOptions } from './config'

export const TreePlusPlusDescription = {
  name: 'Tree++',
  component: React.lazy(() => import('./TreePlusPlus' )),
  label: 'Tree++',
  icon: 'lucide-list-tree',
  variables: configOptions,
}
